/**
 * Timekeeper manages timestamps for a specific context (e.g., 'producer' or 'playback').
 * Use named instances to avoid conflicts when both producer and playback run in the same context.
 */
export class Timekeeper {
    // Named instances instead of single singleton
    static instances = new Map();
    static DEFAULT_INSTANCE_NAME = 'default';
    /**
     * Get a Timekeeper instance by name.
     * @param name Instance name (e.g., 'producer', 'playback'). Defaults to 'default'.
     */
    static getInstance(name) {
        const instanceName = name ?? Timekeeper.DEFAULT_INSTANCE_NAME;
        let instance = Timekeeper.instances.get(instanceName);
        if (!instance) {
            instance = new Timekeeper();
            Timekeeper.instances.set(instanceName, instance);
            console.log(`[Timekeeper] created instance '${instanceName}'`);
        }
        return instance;
    }
    lastTimestampMicros = 0n;
    constructor() { }
    setLastTimestampMicros(timestampMicros, source) {
        const previousValue = this.lastTimestampMicros;
        const jump = Number(timestampMicros - previousValue) / 1000;
        // Log if there's a large jump (> 1 second)
        if (Math.abs(jump) > 1000) {
            console.warn(`[Timekeeper] LARGE JUMP detected: ${jump.toFixed(1)}ms`, {
                source: source ?? 'unknown',
                previousMs: (Number(previousValue) / 1000).toFixed(1),
                newMs: (Number(timestampMicros) / 1000).toFixed(1),
            });
        }
        this.lastTimestampMicros = timestampMicros;
    }
    getLastTimestampMicros() {
        return this.lastTimestampMicros;
    }
}
